// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"Verify_pattern-gradient__QgMP2","page":"Verify_page__pB7Td","form":"Verify_form__P4OXk Signup_component__LIiAk"};